import { Step1Svg, Step2Svg, Step3Svg, Step4Svg, Step5Svg } from './svg';

const StepMeta: Record<number, { title: string; description: string; icon: React.ReactNode; guideKey?: string }> = {
    1: {
        title: 'آدرس پیج اینستاگرام',
        description: 'آیدی پیج اینستاگرامت رو ثبت کن تا برنامه اش رو برات آماده کنیم.',
        icon: <Step1Svg />,
        guideKey: 'first_form_1'
    },
    2: {
        title: 'حوزه کاری پیجتو انتخاب کن',
        description:
            'حوزه‌ای را انتخاب کن که کاملاً با محتوای پیج هماهنگ باشد. این انتخاب پس از ثبت قابل تغییر نیست، ویا نزدیک‌ترین مورد را انتخاب کن.',
        icon: <Step2Svg />,
        guideKey: 'first_form_2'
    },
    3: {
        title: 'توضیحات پیج اینستاگرام',
        description:
            'یک توضیح کوتاه و درست در زمینه فعالیت پیجت و کاری که تو اینستاگرام انجام میدی برامون بنویس. پیشنهاد می‌کنیم حتما ویدیوهای راهنما رو ببینی تا با ورود درست اطلاعات بهترین بازخورد رو از برنامه و پیشنهادات اینستاکلاب داشته باشی.',
        icon: <Step3Svg />,
        guideKey: 'first_form_3'
    },
    4: {
        title: 'جزئیات زمانبندی',
        description: 'تاریخ شروع برنامه ات از چه روزی باشه؟',
        icon: <Step4Svg />,
        guideKey: 'first_form_4'
    },
    5: {
        // description: 'سبک ویدیویی که الان کار میکنی چیه که تا مطابق همون سبک ها بهت پیشنهاد بشه', //when eng is up
        title: 'انتخاب سبک ویدیویی',
        description:
            'سبک ویدیویی که میخوای فعالیت کنی رو انتخاب کن تا ویدیوهای پیشنهادی و راهنمایی ها مطابق همون سبک‌ها بهت پیشنهاد بشه',
        icon: <Step5Svg />,
        guideKey: 'first_form_5'
    }
};

export default StepMeta;

